export default __webpack_public_path__ + "static/media/createfolio_icon.cc916fcb.svg";